<template>
  <section ref="anchor" class="registration">
    <div class="registration__content">
      <div class="registration__content_left">
        <div class="clue">{{ content.clue }}</div>
      </div>

      <div class="registration__content_right">
        <div class="font-medium block__title">
          <span class="block__title_one">{{ content.titleOne }}</span>

          <span class="block__title_two">{{ content.titleTwo }}</span>

          <span class="block__title_one">{{ content.titleThree }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { electronicRequirementData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicRequirement',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicRequirementData,
    }
  },
}
</script>

<style lang="sass" scoped>
.registration
  padding: 0 $desktopHorizontalPaddings 8rem
  @media (max-width: 1279px)
    padding: 0 $mobileHorizontalPaddings 4rem
  &__content
    display: flex
    justify-content: space-between
    width: 100%
    gap: 2rem
    @media (max-width: 1024px)
      flex-direction: column
  &__content_left
    width: 30%
    @media (min-width: 1280px) and (max-width: 1919px)
      width: 40%
    @media (max-width: 1280px)
      width: 100%
      display: flex
      justify-content: left

  &__content_right
    width: 70%
    display: flex
    flex-direction: column
    gap: 3rem
    @media (min-width: 1280px) and (max-width: 1919px)
      width: 60%
    @media (max-width: 1280px)
      width: 100%

  .block__title
    font-family: $primaryFont
    font-weight: 500
    font-size: 3.2rem
    line-height: 4rem
    @media (min-width: 1280px) and (max-width: 1439px)
      font-size: 3rem
    @media (max-width: 1279px)
      font-size: 2.4rem
    &_two
      font-size: 3.2rem
      line-height: 4rem
      color: $buttonPrimary
      @media (min-width: 1280px) and (max-width: 1439px)
        font-size: 3rem
      @media (max-width: 1279px)
        font-size: 2.4rem
</style>
